{
  "#APP_OVERVIEW": {
    "ALL_APPLICATIONS": "Alle Applikationen",
    "MY_APPLICATIONS": "Meine Applikationen",
    "FAVORITES": "Favoriten",
    "SEARCH": "Alle Applikationen durchsuchen...",
    "GRID": "Rasteransicht",
    "LIST": "Listenansicht",
    "INFO_TOOLTIP": "Modulinfo anzeigen",
    "INFO": {
      "module": "Modul",
      "library": "Bibliothek",
      "route": "Route",
      "permission": "Berechtigung",
      "group": "Gruppe"
    },
    "CONFIG_TITLE": "Konfiguration",
    "CONFIG_DEFAULT": "Standard",
    "CONFIG_SOURCE_APP": "App",
    "REMOTE_CONFIG_TITLE": "Server-Konfiguration (WebAppVw)",
    "REMOTE_CONFIG_LOADING": "Wird geladen …",
    "REMOTE_CONFIG_ERROR": "Konfiguration konnte nicht geladen werden",
    "REMOTE_CONFIG_MISSING": "Keine Einträge am Server",
    "BACKEND_TITLE": "Backend-Dienste",
    "BACKEND_SESSION": "Diese Sitzung",
    "BACKEND_WEBSERVICE": "Webservice",
    "BACKEND_EMPTY": "Noch keine Aufrufe – Modul öffnen, um sie zu erfassen",
    "PERMISSIONS_TITLE": "Berechtigungen",
    "PERMISSION_TILE": "Modul anzeigen",
    "PERMISSION_GRANTED": "Vorhanden",
    "PERMISSION_DENIED": "Fehlt",
    "PERMISSION_LOCALHOST": "Auf localhost immer vorhanden",
    "PERMISSION_COPY": "Berechtigung kopieren",
    "YES": "Ja",
    "NO": "Nein",
    "NOT_SET": "nicht gesetzt",
    "CONFIG": {
      "hideWeatherSection": "Wetterbereich ausblenden",
      "showDrawPad": "Unterschriftenfeld anzeigen",
      "enablePositionCopy": "Positionen kopieren",
      "showMusterQuickLink": "Schnellzugriff Musterbelege",
      "showCopyAction": "Kopieren-Aktion",
      "showItemComment": "Positionskommentar",
      "showVermerkInput": "Vermerk-Eingabe",
      "showVermerkInternInput": "Interner Vermerk",
      "employeeSelection": "Mitarbeiterauswahl",
      "appointmentTypeSelection": "Terminart-Auswahl",
      "hideCurrentAmount": "Aktuelle Menge ausblenden",
      "clickAction": "Klick-Aktion",
      "useSecondaryBorderStyle": "Sekundärer Rahmenstil",
      "hideEntryInDetails": "Eintrag in Details ausblenden",
      "allowDelete": "Löschen erlaubt",
      "editableWeeksBeforeToday": "Bearbeitbare Wochen rückwirkend",
      "editableDaysBeforeToday": "Bearbeitbare Tage rückwirkend",
      "resetPartyAfterCreate": "Partei nach Anlage zurücksetzen",
      "actions": "Aktionen",
      "label": "Bezeichnung",
      "icon": "Symbol",
      "actionType": "Aktionstyp",
      "geschaeftsfall": "Geschäftsfall",
      "download": "Download",
      "belegart": "Belegart",
      "strategies": "Strategien",
      "stornoAnzeigen": "Storno anzeigen",
      "deliveryNoteProcessing": "Lieferscheinbearbeitung",
      "dierektannahme": "Direktannahme",
      "reklamation": "Reklamation",
      "lagerplatzauswahl": "Lagerplatzauswahl",
      "ekBarcode": "EK-Barcode",
      "palletDetailFlow": "Paletten-Detailerfassung",
      "showReKundeInsteadOfKunde": "Rechnungskunde statt Kunde",
      "disablePalettenbegleitscheine": "Palettenbegleitscheine deaktiviert",
      "showLessInfoInArticleView": "Reduzierte Artikelansicht",
      "showConfirmationOnFinalize": "Bestätigung beim Abschließen",
      "pallet": "Paletten",
      "showKilometerInput": "Kilometer-Eingabe",
      "autofocusKilometers": "Kilometer fokussieren",
      "showReturnNoteScanOption": "Rücknahmeschein scannen",
      "openDialogMaxMenge": "Dialog bei Maximalmenge",
      "dashboardInfo": "Dashboard",
      "title": "Titel",
      "subtitle": "Untertitel",
      "demoMode": "Demo-Modus",
      "spezialStempelBemerkungPflicht": "Bemerkung bei Spezialstempel Pflicht",
      "readonly": "Nur lesen",
      "hasProductDescriptionFeature": "Produktbeschreibung",
      "storageSelection": "Lagerauswahl"
    }
  }
}
